// API Endpoints
export const API_ENDPOINTS = {
    WORKSPACES: '/workspaces',
    WORKSPACE_DETAIL: '/workspaces/:id',
    INVITE_MEMBER: '/workspaces/:id/invite',
    UPDATE_MEMBER: '/workspaces/:id/members/:userId',
    USER_PROFILE: '/user/profile',
};
//# sourceMappingURL=api-endpoints.js.map